
import React, { createContext, useContext } from "react";
import { Page, DeviceSpecificSettings } from "../types/page";
import { TitleConfig } from "@/types/TitleConfig";
import { usePageContextState } from "../hooks/usePageContextState";

interface PageContextType {
  pages: Page[];
  setPages: React.Dispatch<React.SetStateAction<Page[]>>;
  titleConfig: TitleConfig;
  setTitleConfig: React.Dispatch<React.SetStateAction<TitleConfig>>;
  deviceSpecificSettings: DeviceSpecificSettings;
  setDeviceSpecificSettings: React.Dispatch<React.SetStateAction<DeviceSpecificSettings>>;
  rotationInterval: number;
  setRotationInterval: React.Dispatch<React.SetStateAction<number>>;
  autoScroll: boolean;
  setAutoScroll: React.Dispatch<React.SetStateAction<boolean>>;
  currentPageIndex: number;
  setCurrentPageIndex: React.Dispatch<React.SetStateAction<number>>;
  isHebrew: boolean;
  toggleLanguage: () => void;
  isLoading: boolean;
  currentUser: any | null;
}

export const PageContext = createContext<PageContextType | undefined>(undefined);

export const PageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const contextState = usePageContextState();
  
  return (
    <PageContext.Provider value={contextState as PageContextType}>
      {children}
    </PageContext.Provider>
  );
};

export const usePageContext = (): PageContextType => {
  const context = useContext(PageContext);
  if (context === undefined) {
    throw new Error("usePageContext must be used within a PageProvider");
  }
  return context;
};
